/**
 * SpectatorAliasRedirect — Resolves a friendly alias to a share_id and redirects.
 * URL: /live/a/:alias  →  /live/:shareId
 */
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'

export default function SpectatorAliasRedirect() {
  const { alias } = useParams<{ alias: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!alias) return
    const resolve = async () => {
      try {
        const res = await axios.get(`/api/v1/workspace/spectator/alias/${alias}/resolve`)
        navigate(`/live/${res.data.share_id}`, { replace: true })
      } catch {
        setError('expired')
      }
    }
    resolve()
  }, [alias, navigate])

  if (error) {
    return (
      <div className="min-h-screen bg-[#0a0a14] flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-purple-500/10 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-purple-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-white mb-2">Session Not Available</h1>
          <p className="text-gray-400 mb-6">This live session hasn't started yet or has ended.</p>
          <a
            href="https://ecosemantic.com"
            className="text-purple-400 hover:text-purple-300 text-sm"
          >
            Visit ecosemantic.com →
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#0a0a14] flex items-center justify-center p-6">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-4 border-2 border-purple-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-400 text-sm">Connecting to live session…</p>
      </div>
    </div>
  )
}
